export default {
  //get info about room lobby on page load (room-lobby)
  accessGuestLink({dispatch}, token) {
		return dispatch('request', {
			url: `/space/guest/${token}/access`,
			method: 'post',
      requiresAuth: false
		})
	},
	enterGuestRoomLobby({dispatch}, roomId) {
    if(!roomId || roomId == 'undefined') return
		return dispatch('request', {
			url: `/space/guest/${roomId}/enter-lobby`,
			method: 'post'
		})
	},
  //area guest access
  accessGuestSpace({dispatch}, areaId) {
		return dispatch('request', {
			url: `/area/${areaId}/access`,
			method: 'post',
      requiresAuth: false
		})
	},
  //area guest add to collections
  addOpenSpaceToCollection({dispatch}, areaId) {
		return dispatch('request', {
			url: `/area/${areaId}/add-to-collections`,
			method: 'post',
      requiresAuth: false
		})
	},
  //create one time guest login after entering name
  createGuestLogin({dispatch}, [username, locationId]) {
		return dispatch('request', {
			url: `/guest/${locationId}/create-login`,
			method: 'post',
			data: {
        username
			},
      requiresAuth: false
		})
	},
  cancelJoinGuestLobby({dispatch}, roomId) {
		return dispatch('request', {
			url: `/space/guest/${roomId}/cancel-join`,
			method: 'post'
		})
	},
  passwordJoinGuestLobby({dispatch}, [roomId, password]) {
		return dispatch('request', {
			url: `/space/guest/${roomId}/password-join`,
			method: 'post',
			data: {
        password
			}
		})
	},

  // INVITE GUESTS TO ROOM -----------------------------------------------------
  inviteGuestsToRoomByEmail({dispatch}, [roomId, users]) {
		return dispatch('request', {
			url: `/space/guest/${roomId}/invite-external`,
			method: 'post',
      data: {
        users
			}
		})
	},
  // ACCEPT/DECLINE GUESTS IN LOBBY
  acceptLobbyUser({dispatch}, [roomId, userId]) {
		return dispatch('request', {
			url: `/space/guest/${roomId}/accept-lobby-user`,
			method: 'post',
			data: {
        userId
			}
		})
	},
  rejectLobbyUser({dispatch}, [roomId, userId]) {
		return dispatch('request', {
			url: `/space/guest/${roomId}/reject-lobby-user`,
			method: 'post',
			data: {
        userId
			}
		})
	},

  // INVITE GUESTS TO SPACE -----------------------------------------------------
  inviteGuestsToSpaceByEmail({dispatch}, [spaceId, users]) {
		return dispatch('request', {
			url: `/area-management/invites/guest/invite-users`,
			method: 'post',
      data: {
        users,
        areaId: spaceId
			}
		})
	},
}
